import { CurrencyPipe, DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { AccountTransferData } from "../../../account-transfer/account-transfer.model";
import { PromotionType } from "../../../promotion/promotion.model";
import { HorizontalListFactory } from "../../../ui/horizontal-list/horizontal-list.factory";
import { HorizontalListData } from "../../../ui/horizontal-list/horizontal-list.model";
import { TransactionType } from "../../transaction.model";

@Injectable()
export class TransactionDetailsAdapter {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly datePipe: DatePipe) { }

  adaptHorizontalListData = (data: AccountTransferData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Case name',
        displayedValue: data.loan?.description,
        isItemHidden: !data.loan?.description,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Transfer from',
        displayedValue: data?.from,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Transfer to',
        displayedValue: data?.to,
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Payoff interest reduction',
        displayedValue: this.currencyPipe.transform(data?.promotionInfo?.interestRateReducement, '$'),
        isItemHidden: data?.type !== TransactionType.Payment || data?.promotionInfo?.promotionType !== PromotionType.PayoffInterestReduction
      }),
      HorizontalListFactory.createInfoStringItem({
        displayedValue: 'Loan will be re-amortized after payment is made',
        isItemHidden: data?.type !== TransactionType.Payment || data?.promotionInfo?.promotionType !== PromotionType.ReAmortization,
      }),
      HorizontalListFactory.createInfoStringItem({
        displayedValue: 'Transfers to and from your bank account are done through the Automated Clearing House (ACH) Network. Transfers take 1-2 business days to be processed.',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Fee amount',
        displayedValue: this.currencyPipe.transform(data?.fee, '$'),
        isItemHidden: data?.type !== TransactionType.Draw
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Third party payoff amount',
        displayedValue: this.currencyPipe.transform(data?.thirdPartyPayoffAmount, '$'),
        isItemHidden: data?.type !== TransactionType.Draw || !data?.thirdPartyPayoffAmount
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Promotional fee reduction',
        displayedValue: this.currencyPipe.transform(data.promotionInfo?.drawFeeReducement, '$'),
        isItemHidden: data?.type !== TransactionType.Draw || !data?.promotionInfo
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Disbursed amount',
        displayedValue: this.currencyPipe.transform(data?.disbursedAmount || 0, '$'),
        isItemHidden: data?.type !== TransactionType.Draw
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'New outstanding balance',
        displayedValue: this.currencyPipe.transform(data?.balanceAfter?.outstandingBalance, '$'),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'New available funds',
        displayedValue: this.currencyPipe.transform(data?.balanceAfter?.availableBalance, '$'),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Old payment due',
        displayedValue: this.currencyPipe.transform(data?.loan?.paymentAmount, '$'),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'New payment due',
        displayedValue: this.currencyPipe.transform(data?.balanceAfter?.upcomingPaymentAmount, '$'),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Payment due date',
        displayedValue: this.datePipe.transform(data?.balanceAfter?.upcomingPaymentDate),
      }),
    ]
  }
}
